import { Card, CardContent } from '@components/card';
import { BaseLayout } from '@layouts/base';
import {
  createFileRoute,
  redirect,
  useNavigate,
  useParams,
  useSearch,
} from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { ApiKeyForm } from '@components/forms/apiKeys/index';
import { useGetPermissionGroups } from '@services/acquirer/apiKeys/permissionGroups';
import { useCreateApiKey } from '@services/staff/acquirer/apiKeys/create';
import { useGetApiKey } from '@services/staff/acquirer/apiKeys/get';
import { useApiKeyForm } from '@hooks/forms/apiKeys';

const NewApiKey = () => {
  const { t } = useTranslation('app');
  const { localId, acquirerId } = useParams({
    from: '/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys/new',
  });
  const { duplicateFrom } = useSearch({ strict: false });
  const navigate = useNavigate();
  const { data: sourceApiKey } = useGetApiKey({ id: duplicateFrom || '', acquirerId });
  const { data: permissions } = useGetPermissionGroups();

  const requestHandler = useCreateApiKey({
    acquirerId,
    callback: () => {
      toast.success(t('toast.apiKeys.createSuccess'));
      navigate({
        to: '/u/$localId/staff/acquirers/$acquirerId/api-keys',
        params: { localId, acquirerId },
        replace: true,
      }).catch((err) => {
        console.error(err);
      });
    },
  });

  const form = useApiKeyForm({ apiKey: duplicateFrom ? sourceApiKey : undefined, requestHandler });

  return (
    <BaseLayout isChild title={t('pages.apiKeys.create')}>
      <Card>
        <CardContent className="p-6">
          {permissions && (
            <ApiKeyForm
              formObj={form}
              permissions={permissions}
              buttonText={t('form.submit.apiKeyCreate')}
            />
          )}
        </CardContent>
      </Card>
    </BaseLayout>
  );
};

export const Route = createFileRoute('/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys/new')(
  {
    beforeLoad: ({ context }) => {
      if (!context.userHasPermissions(['api_keys_create'])) {
        throw redirect({
          to: `/u/$localId/${context.userType}/forbidden`,
        });
      }
    },
    component: NewApiKey,
  },
);
